"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPrettyName(method) {
  return method
    .replace(/^list/, "")
    .replace(/^describe/, "")
    .replace(/^get/, "");
}
exports.getPrettyName = getPrettyName;
function getDisplayName(name) {
  if (!name) return;
  name = name
    .replace(/^describe/, "")
    .replace(/^get/, "")
    .replace(/^list/, "");
  let displayName = name.charAt(0).toUpperCase() + name.slice(1);
  return displayName.split(/(?=[A-Z].)/).join(" ");
}
exports.getDisplayName = getDisplayName;
exports.addFunctionToSnippet = snippet => {
  if (snippet == "") snippet = "\n\n\treturn true;\n";
  return "function(obj){" + snippet.replace(/\$/g, "obj") + "}";
};
exports.removeFunctionFromSnippet = snippet => {
  return (
    snippet
      .slice(snippet.indexOf("{") + 1, snippet.lastIndexOf("}"))
      // .trim()
      .split("obj")
      .join("$")
  );
};
exports.selectedResourceNotEquals = (x, selectedResource) => {
  return (
    x.selectedResourceId !== selectedResource.selectedResourceId &&
    x.path !== selectedResource.path
  );
};
exports.selectedResourceEquals = (x, selectedResource) => {
  return (
    x.selectedResourceId === selectedResource.selectedResourceId &&
    x.path === selectedResource.path
  );
};
function capitalize(text) {
  const letters = text.split("");
  if (letters[0]) {
    letters[0] = letters[0].toUpperCase();
  }
  return letters.join("");
}
function wordify(text) {
  let words = capitalize(text).split(/([A-Z][a-z]+)/g);
  return words
    .map(v => capitalize(v))
    .filter(x => x)
    .join(" ");
}
exports.wordify = wordify;
exports.getSgcData = async (dataResolver, key) => {
  let resolverError = null;
  if (!dataResolver) return null;
  const data = dataResolver.resolve("getSGCTypeDefinition", key, error => {
    resolverError = error;
  });
  if (resolverError) {
    console.error("Error in getting sgc data", resolverError);
    return null;
  }
  return data;
};
//# sourceMappingURL=utils.js.map
